import React from 'react';
import { prevArrow, nextArrow } from '../Arrows';
import Slider from 'react-slick';
import slide1 from './assets/slide1.png';
import slide2 from './assets/slide2.jpg';
import slide3 from './assets/slide3.png';
import slide4 from './assets/slide4.png';
import styles from './styles.scss';

function Testimonials () {
  const settings = {
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    infinite: true,
    arrows: true,
    nextArrow: nextArrow('#999'),
    prevArrow: prevArrow('#999')
  };

  return (
    <section className={`${styles.container} mtb150`}>
      <Slider {...settings}>
        <div>
          <div>
            <p className="demi-bold text-center">Logo and Branding</p>
            <img className={styles.image} src={slide1} alt="slide 1" />
          </div>
        </div>
        <div>
          <div>
            <p className="demi-bold text-center">Marketing and Social Assets</p>
            <img className={styles.image} src={slide2} alt="slide 2" />
          </div>
        </div>
        <div>
          <div>
            <p className="demi-bold text-center">Wireframing and Screenflow</p>
            <img className={styles.image} src={slide3} alt="slide 3" />
          </div>
        </div>
        <div>
          <div>
            <p className="demi-bold text-center">UI Kits and Style Guides</p>
            <img className={styles.image} src={slide4} alt="slide 4" />
          </div>
        </div>
      </Slider>
    </section>
  );
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/StartupIncludes/index.js